import type {} from '@redux-devtools/extension' 
import Questionizer from './components/questionizer';
import { useEffect } from 'react';
import { useQuestionizerStore } from './types/state';
import { TranslationMap } from './translation';
import { QuestionizerConfig } from './types/questionizer-config';

export default function App(props: {className?: string, config?: QuestionizerConfig, configPath: string | null | undefined, translation_map?: TranslationMap}) {
  const config = useQuestionizerStore((state) => state.config);
  const loadConfig = useQuestionizerStore((state) => state.loadConfig);
  const initializeConfig = useQuestionizerStore((state) => state.initializeConfig);
  const requestStatistics = useQuestionizerStore((state) => state.requestStatistics);
  const setTranslationMap = useQuestionizerStore((state) => state.setTranslationMap);

  const sendStatisticsInterval = 3000; //3 seconds
  
  useEffect(()=>{
    if (config){ return; } 

    if(props.configPath){
      loadConfig(props.configPath);
    } else if (props.config) {
      initializeConfig(props.config);
    }

    requestStatistics();
    setTranslationMap(props.translation_map);
    const interval = setInterval(()=>{
      requestStatistics();
    }, sendStatisticsInterval);
    return ()=>{clearInterval(interval)};
  },[]);

  if (!config) { return; }

  const style = config.style;
  const parsed_style = style ? Object.keys(style)
    .map(selector => {
      const prefixed = selector === ''
        ? '.questionizer-root'
        : selector.split(',').map(s => '.questionizer-root ' + s.trim()).join(', ');
      const props = Object.entries(style[selector])
        .map(([k, v]) => `${k}:${v}`)
        .join(';');
      return `${prefixed}{${props}}`;
    })
    .join(' ') : '';

    return <>
        <style>{parsed_style}</style>
        <Root className={props.className}/>
    </>
  }

function Root(props: {className?: string}){
  return <div className={"questionizer-root questionizer-container w-full h-full flex flex-col font-sans "+(props.className || "")}>
      <Questionizer />
  </div>
}